export default __webpack_public_path__ + "static/docker-extension-meshery-0a2d7381010c388c67ac3f07175a0581.webp";